import React from "react";
import NoticePeriodSection from "./noticePeriod/NoticePeriodSection";

const SeparationConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <NoticePeriodSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default SeparationConfigSection;
